export const arrayUniq = (array: Array<any>) => (
  array.filter((elem: any, pos: number, _) => array.indexOf(elem) == pos)
)

export const setDatetimePickerDefaults = () => {
  $.extend(true, $.fn.datetimepicker.defaults, {
    icons: {
      time: 'bi bi-clock',
      date: 'bi bi-calendar3',
      up: 'bi bi-chevron-up',
      down: 'bi bi-chevron-down',
      previous: 'bi bi-chevron-left',
      next: 'bi bi-chevron-right',
      today: 'bi bi-crosshair',
      clear: 'bi bi-trash',
      close: 'bi bi-x'
    }
  })
}

export const limitTextAreaChars = (modal: JQuery) => {
  const target = $("[data-chars-left-limit]")
  if (target.length < 1) return

  const { charsLeftLimit, charsLeftLimitAlertMsg } = target.data()
  const textarea = $("textarea", modal)
  const ctaBtn = $("#form_cta_btn", modal)

  const setText = (textarea: JQuery) => {
    const val = textarea.val() as Array<string>
    target.text(`${val.length} / ${charsLeftLimit}`)

    if (val.length > charsLeftLimit) {
      target.addClass("text-danger")
      ctaBtn.prop("disabled", true)
      ctaBtn.css("cursor", "default")
    } else {
      target.removeClass("text-danger")
      ctaBtn.prop("disabled", false)
      ctaBtn.css("cursor", "pointer")
    }
  }

  setText(textarea)

  textarea.on("keyup", function() {
    setText($(this))
  })

  ctaBtn.on("mouseover", function() {
    if (ctaBtn.prop("disabled") && !ctaBtn.attr("data-showed-alert")) {
      alert(charsLeftLimitAlertMsg)
      ctaBtn.attr("data-showed-alert", "true")
    }
  })
}
